import CardConvidado from './CardConvidado'

export default CardConvidado